import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ServicesJelpitService } from '@services/services-jelpit/services-jelpit.service';
import { ILibTbModalNotification } from 'tech-block-lib';
import { ConfirmationService } from 'primeng/api';
import { BehaviorSubject, Subscription } from 'rxjs';

declare const dataLayer: any;
@Component({
  selector: 'app-no-tc-davivienda',
  templateUrl: './no-tc-davivienda.component.html',
  styleUrls: ['./no-tc-davivienda.component.scss'],
})
export class NoTcDaviviendaComponent implements OnInit, OnDestroy{

  public envUrl : string = '';
  public subscription: Subscription;
  public modalData: ILibTbModalNotification = {
    key: 'modalError',
    closeOnEscape: true,
    showClose: true,
    dismissableMask: false,
    acceptButtonVisible: false,
    rejectButtonVisible: false,
    class: 'modal-login',
    libTbOnClose: () => {
      if(this.modal === 'NoExistingTC') {
        this.tagTcDavivienda('cerrar');
      }
    }
  };
  public modalTypes: Array<string> = ["NoExistingTC", "InactiveTC"];
  public modal: string;
  @Input() modalType: BehaviorSubject<string>;

  constructor(private route: Router, private jelpitService: ServicesJelpitService, private confirmationService: ConfirmationService) {
    this.envUrl = jelpitService.envUrl;
  }

  ngOnInit(): void {
    this.subscription = this.modalType.subscribe({
      next: response => {
        this.modal = response;
        this.openModal(this.modal);
      }
    });
  }

  ngOnDestroy(): void {
      this.subscription.unsubscribe();
  }
  /**
   * The function redirects the user to a specified URL.
   */
  goToJelpit() {
    location.href = this.envUrl;
  }

  /**
   * The function redirects the user to a specified URL.
   */
  goToDavivienda() {
    window.open('https://www.daviviendamovil.com/productos/tarjetas-credito/tarjeta-de-credito', "_blank", 'noopener, noreferrer');
  }


  //39F
  tagTcDavivienda(label: string) {
    dataLayer.push({
      'event': 'ga_event',
      'category': 'tarjeta davivienda',
      'action': 'JPW- solicitar tarjeta davivienda',
      'label': label
    })
  }

  /**
   * The function `openModal` checks if a specified modal type is included in a list and then triggers
   * a confirmation modal if it is.
   * @param {string} modalError - The `modalError` parameter in the `openModal` function is a string
   * that represents the type of modal that needs to be opened. The function checks if the `modalError`
   * is included in the `modalTypes` array before opening the modal. If it is included, a confirmation
   * modal is opened.
   */
  openModal(modalError: string) {
    if(this.modalTypes.includes(modalError)){
        this.confirmationService.confirm({
          key: 'modalError',
          reject: () => {}
        });
    }
  }
}
